export enum MixinType {
    CONST, FUNC, LINK
}
